import Avatar from '@components/Avatar';
import { LinkButton, LinkButtonContent } from '@components/LinkButton';
import Loader from '@components/Loader';
import { Text } from '@components/Text';
import useImpersonate from '@State/Impersonate/useImpersonate';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { size } from './layout/helpers';

const ImpersonateBarWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: ${(props) => props.theme.zindex.stateBar};
  background-color: ${(props) => props.theme.color.primary.anthracite};
  color: ${(props) => props.theme.color.text.inverted};
  height: ${(props) => props.theme.size.impersonateBarHeight};
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;

  ${(props) => props.theme.breakpoint.LtSm} {
    padding: 16px;
    gap: 0;
    justify-content: space-between;
    height: ${(props) => props.theme.size.impersonateBarHeightMobile};
    width: 100%;
  }
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${size(1)};
  padding-right: ${size(3)};
  border-right: 1px solid rgba(255, 255, 255, 0.2);

  ${(props) => props.theme.breakpoint.LtSm} {
    padding: 0;
    border: none;
  }
`;

const ActionSection = styled.div`
  display: flex;
  align-items: center;
`;

const ImpersonateBar: React.FC = () => {
  const { t } = useTranslation();
  const { impersonate, requestRemoveImpersonate, removeImpersonate } = useImpersonate();
  const navigate = useNavigate();

  if (!impersonate) {
    return null;
  }

  const handleTerminateImpersonation = () => {
    removeImpersonate();
    navigate('/users');
  };

  return (
    <ImpersonateBarWrapper>
      <UserSection>
        <Avatar
          initials={`${impersonate.firstName?.substring(0, 1)}${impersonate.lastName?.substring(
            0,
            1
          )}`}
          size="small"
        />
        <Text>
          {impersonate.firstName} {impersonate.lastName}
        </Text>
      </UserSection>

      <ActionSection>
        <LinkButton
          onClick={handleTerminateImpersonation}
          title={t('impersonate_bar_terminate_button_title', {
            user: `${impersonate.firstName} ${impersonate.lastName}`,
          })}
          $tone="inverted"
          disabled={requestRemoveImpersonate.loading}
          $hasContent
        >
          <LinkButtonContent style={{ display: 'flex', alignItems: 'center', gap: size(1) }}>
            {t('impersonate_bar_terminate_button_text')}
            {requestRemoveImpersonate.loading && <Loader inlineBlock />}
          </LinkButtonContent>
        </LinkButton>
      </ActionSection>
    </ImpersonateBarWrapper>
  );
};

export default ImpersonateBar;
